import { stringifyCaseFile } from '@/pages/projections/caseJson'

export function downloadTextFile(filename: string, body: string, mime: string): void {
  const blob = new Blob([body], { type: `${mime};charset=utf-8` })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}

export function downloadJsonFile(filename: string, value: unknown): void {
  downloadTextFile(filename, stringifyCaseFile(value), 'application/json')
}

export function downloadCsvFile(filename: string, csvBody: string): void {
  downloadTextFile(filename, csvBody, 'text/csv')
}

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
